module.exports = "/packs/pattern-right-blue-241510b2a7d908343c6cc85dfbd2871a.png";